import { useRef, useEffect } from 'react'
import { Collapse as CollapseAntd } from 'antd'
import { Input } from '../../../../components/Input'
import { Collapse } from '../../../../components/Collapse'
import { RejectedInvoiceDetails } from '../RejectedInvoiceDetails/RejectedInvoiceDetails'
import { ExportRejectedInvoices } from '../ExportRejectedInvoices/ExportRejectedInvoices'
import { Loader } from '../../../Financials/AdminSplitFees/Loader'
import { Typography } from '../../../../components/Typography'
import { Button } from '../../../../components/Button'
import { FloatFooter } from '../../../../components/FloatFooter/FloatFooter'
import { useRejectedInvoicesListContext } from '../Providers/RejectedInvoicesListContextProvider'
import { SORT_OPTIONS } from '../constants'
import { ReactComponent as Close16 } from 'assets/svg/Clos16.svg'
import { ReactComponent as Search16 } from 'assets/svg/Search16.svg'
import { ReactComponent as SortingDefault16 } from 'assets/svg/SortingDefault16.svg'
import { ReactComponent as EmptyLarge } from 'assets/svg/EmptyLarge.svg'
import { PLACEHOLDERS } from '../../../../constants'
import { BTN_TXT } from '../../../../constants'
import './styles.scss'

const { Panel } = CollapseAntd

export const RejectedInvoicesList = () => {
  const { actions, state } = useRejectedInvoicesListContext()
  const sentinelRef = useRef(null)
  const {
    searchValue,
    rejectedInvoices,
    firstLoad,
    isActive,
    activeKey,
    selectedSort,
    loadingMore
  } = state
  const {
    onSave,
    onCancel,
    onChange,
    setSelectedSort,
    setSearchValue,
    handleLoadMore
  } = actions

  useEffect(() => {
    const sentinelElement = sentinelRef.current
    if (!sentinelElement) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loadingMore && !firstLoad) {
          handleLoadMore()
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 1.0
      }
    )
    observer.observe(sentinelElement)
    return () => {
      observer.unobserve(sentinelElement)
    }
  }, [loadingMore, firstLoad, handleLoadMore])

  return (
    <div className="table-wrapper rejected-invoices">
      <div className="table-wrapper__header">
        <Input
          className="allow-clear"
          propsInput={{
            allowClear: { clearIcon: <Close16 /> },
            placeholder: PLACEHOLDERS.SEARCH,
            prefix: <Search16 />,
            value: searchValue,
            onChange: (e) => setSearchValue(e.target.value)
          }}
        />
        <div className="row gap-8">
          <Button.Menu
            className="create-chat-button"
            icon={<SortingDefault16 />}
            selectedValue={selectedSort}
            options={SORT_OPTIONS.map((i) => ({
              ...i,
              onClick: () => setSelectedSort(i.value)
            }))}
            upperCase
          >
            {BTN_TXT.SORT}
          </Button.Menu>
          <ExportRejectedInvoices />
        </div>
      </div>
      {!rejectedInvoices.length && !firstLoad && !loadingMore && (
        <div className="rejected-invoices__empty-state column align-center">
          <EmptyLarge />
          <Typography.Headline6 className="mt-24">
            Great news! You have no rejected invoices.
          </Typography.Headline6>
        </div>
      )}
      {!!rejectedInvoices.length && (
        <Collapse activeKey={activeKey} onChange={onChange}>
          {rejectedInvoices.map((i) => (
            <Panel key={i.invoice_key} header={i.invoice_key}>
              <RejectedInvoiceDetails data={i} />
            </Panel>
          ))}
        </Collapse>
      )}
      <div ref={sentinelRef} style={{ height: '10px' }} />
      {loadingMore && <Loader itemsLength={rejectedInvoices.length} />}
      <FloatFooter
        isActive={isActive}
        onCancel={onCancel}
        onSave={onSave}
        withConfirm
      />
    </div>
  )
}
